import { AppForm } from '../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class ExecutionOfTrafficOrganizationProjectsForm extends AppForm {

  constructor() {
    super({
      projectType: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      applicationSubject: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      geometry: new FormControl(null, Validators.required)
    });
  }

  public get geometry(): FormControl {
    return this.get('geometry') as FormControl;
  }

}
